var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59,0H1C0.4,0,0,0.4,0,1v46c0,0.6,0.4,1,1,1h4v11c0,0.6,0.4,1,1,1h48c0.6,0,1-0.4,1-1V48h4c0.6,0,1-0.4,1-1V1 C60,0.4,59.6,0,59,0z M58,2v6H2V2H58z M53,24H7v-6h46V24z M7,58V26h46v32H7z M55,46V17c0-0.6-0.4-1-1-1H6c-0.6,0-1,0.4-1,1v29H2 V10h56v36H55z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,47h16c0.6,0,1-0.4,1-1V30c0-0.6-0.4-1-1-1H11c-0.6,0-1,0.4-1,1v16C10,46.6,10.4,47,11,47z M12,39h6v6h-6V39z M20,45 v-6h6v6H20z M26,37h-6v-6h6V37z M18,31v6h-6v-6H18z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 29,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 33,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 33,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 33,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 33,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 33,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 29,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 29,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 37,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 41,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 45,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 51,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 51,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 51,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 51,
    width: 27,
    height: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.ded622ca5a147425746d2710a8964242.svg";
export { ForwardRef as ReactComponent };